<template>
  <div class="sp_menu">
    <div class="humberger_menu">
      <div class="humberger" :class="{active: menuMode}" @click="show_menu">
        <hr>
        <hr>
        <hr>
      </div>
    </div>
    <!-- <Tokkyo class="lrwidth sp_hidden" /> -->
    <!-- <div class="scroll_area" :class="{active: isMenu}">
      <div class="menu_list">
        <div class="close_button" @click="close_menu">
          <img src="/img/menu_close.png">
        </div>
        <div class="pc_flex">
          <div class="menu_button">
            <a @click="page('/my-page')"><img src="/img/mypage.png">{{t('マイページ')}}</a>
          </div>
          <div class="menu_button">
            <a @click="page('/buy-point-history')"><img src="/img/point.png">{{t('ポイント履歴')}}</a>
          </div>
          <div class="menu_button">
            <a @click="page('/terms-of-service')"><img src="/img/note.png">{{t('利用規約 ')}}</a>
          </div>
          <div class="menu_button">
            <a @click="page('/user-guide')"><img src="/img/help.png">{{t('ご利用ガイド')}}</a>
          </div>
          <div class="menu_button">
            <a @click="page('/buy-point')"><img src="/img/footer-point.png">{{t('ポイント購入')}}</a>
          </div>
          <div class="menu_button">
            <a @click="page('/buy-product-history')"><img src="/img/footer-history.png">{{t('商品購入履歴')}}</a>
          </div>
        </div>
        <div class="logout" v-if="currentUser.is_login == '1'" @click="logout">
          <div><img src="/img/logout.png">{{t('ログアウト')}}</div>
        </div>
        <div class="logout" v-if="currentUser.is_login == '0'" @click="page('/login')">
          <div><img src="/img/login.png">{{t('ログイン')}}</div>
        </div>
        <hr>
        <div class="pc_flex footer">
          <div>
            <a @click="page('/point-terms-of-service')">{{t('ポイント利用規約')}}</a>
          </div>
          <div>
            <a @click="page('/fund-settlement')">{{t('資金決済法に基づく表記')}}</a>
          </div>
          <div>
            <a @click="page('/specific-commerce')">{{t('特定商取引法に基づく表記')}}</a>
          </div>
          <div>
            <a @click="page('/privacy-protection')">{{t('個人情報保護ポリシー')}}</a>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import Tokkyo from '@/components/molecules/Header/Tokkyo.vue';
import t from '@/plugins/i18n';

export default {
  mixins: [t],
  props: {
    currentUser: {
      type: Object,
      default: () => {},
    },
    menuMode: {
      type: Boolean,
      default: false,
    },
  },

  // components: {
  //   Tokkyo,
  // },

  data: () => ({
    isMenu: false,
  }),

  computed: {
    ...mapGetters({
      logOutUserResult: 'user/logOutUserResult',
    }),
  },

  watch: {
    logOutUserResult(newVal) {
      if (newVal) {
        window.location.href = '/';
      }
    },
  },

  methods: {
    show_menu() {
      this.$emit('change_menu', !this.menuMode);
    },
    close_menu() {
      this.isMenu = false;
    },
    page(url) {
      this.$router.push(url);
      this.close_menu();
    },
    logout() {
      this.$store.dispatch('user/logOutUser');
    },
  },
};
</script>

<style lang="scss" scoped>
.sp_menu {
  display: flex;
  align-items: center;
  .humberger_menu {
    margin-right: 10px;
    .humberger {
      border-radius: 50px;
      padding: 10px;
      width: 47px;
      height: 44px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      hr {
        border: solid 1px $black;
        width: 30px;
        transition: .4s;
      }
      &.active {
        hr {
          &:nth-child(1) {
            transform: rotate(-45deg) translateY(5px) translateX(-5px);
          }
          &:nth-child(2) {
            opacity: 0;
          }
          &:nth-child(3) {
            transform: rotate(45deg) translateX(-10px) translateY(-10px);
          }
        }
      }
    }
  }
  .scroll_area {
    display: none;
  }
}

.pc_flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  .menu_button {
    a {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: $black;
      padding: 30px 60px;
      img {
        margin-right: 5px;
        width: 20px;
      }
    }
  }
  &.footer {
    div {
      margin: 0 30px;
    }
  }
}

.sp_menu {
  z-index: 10;
}
.scroll_area {
  overflow-y: auto;
  position: fixed;
  right: -340px;
  top: 0;
  padding-top: 120px;
  width: 100vw;
  height: 100%;
  overflow-y: auto;
  transition: 0.4s;
  z-index: 10010;
  background-color: rgba(0, 0, 0, 0.4);
  .menu_list {
    right: 10px;
    top: 10px;
    color: #f5c236;
    width: 100%;
    background-color: #151515;
    padding: 100px 20px 20px 20px;
    .close_button {
      position: absolute;
      top: 39px;
      right: 19px;
      background-color: #BF9507;
      border-radius: 50px;
      padding: 10px;
      display: flex;
      justify-items: center;
      align-items: center;
      cursor: pointer;
      img {
        width: 32px;
      }
    }
    div {
      margin-bottom: 40px;
      margin-left: 10px;
      text-align: center;
      a {
        color: #f5c236;
        text-decoration: none;
      }
    }
    .logout, login {
      display: flex;
      justify-content: center;
      align-items: center;
      div {
        padding: 15px 90px;
        border-radius: 100px;
        cursor: pointer;
        margin-top: 30px;
        margin-bottom: 10px!important;
        border: solid 1px #BF9507;
        color: #BF9507;
        font-weight: bold;
        img {
          margin-right: 10px;
        }
      }
    }

    hr {
      height: 1px;
      background-color: $gray;
      border: none;
      margin-bottom: 40px;
    }

    .copy {
      color: $white;
      font-size: 10px;
      font-weight: normal;
      font-family: auto;
    }
  }
}
.scroll_area.active{
  display: block!important;
  right: 0;
}
@media screen and  (max-width: $tabletWidth) {
  .sp_menu {
    z-index: 10000;
  }
  .humberger_menu {
    position: initial;
    padding: 4px;
    .humberger {
      img {
        width: 25px;
      }
    }
  }
  .scroll_area {
    height: 100vh;
    padding-top: 75px;
    .menu_list {
      padding: 20px 20px 20px 20px;
      div {
        margin-left: 0;
      }
      .close_button {
        position: fixed;
        top: 16px;
        right: 16px;
        img {
          width: 28px;
        }
      }
    }
  }
  .pc_flex {
    flex-direction: column;
    .menu_button {
      margin-bottom: 10px!important;
      a {
        padding: 30px 10px;
      }
    }
    &.footer {
      flex-direction: column;
      div {
        margin: 10px 10px;
      }
    }
  }
  .sp_hidden {
    display: none;
  }
}
</style>
